import { render, staticRenderFns } from "./DueDateFilter.vue?vue&type=template&id=539b2d2f&scoped=true&"
import script from "./DueDateFilter.vue?vue&type=script&lang=js&"
export * from "./DueDateFilter.vue?vue&type=script&lang=js&"
import style0 from "./DueDateFilter.vue?vue&type=style&index=0&id=539b2d2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b2d2f",
  null
  
)

export default component.exports